import IconSvg from 'src/assets/icons/IconSvg';
import type { SortState } from 'src/types/leaderboard';

interface Props {
  label: string;
  field: string;
  currentSort: SortState;
  onSort: (sort: SortState) => void;
}

const SortableColumnHeader = ({ label, field, currentSort, onSort }: Props) => {
  const isActive = currentSort.field === field;

  const handleClick = () => {
    if (!isActive) {
      onSort({ field, order: 'desc' });
    } else if (currentSort.order === 'desc') {
      onSort({ field, order: 'asc' });
    } else {
      onSort({ field: '', order: 'desc' });
    }
  };

  return (
    <button
      className="flex gap-1 items-center cursor-pointer select-none"
      onClick={handleClick}
    >
      <span>{label}</span>
      <IconSvg
        icon="trianglesS"
        className={isActive ? 'text-brand-magnolia' : ''}
      />
    </button>
  );
};

export default SortableColumnHeader;
